import React from 'react';
import { Play } from 'lucide-react';
import TierBadge from './TierBadge';
import { formatCurrency } from '../demoMode';

function toTierValue(profile) {
  if (profile?.tier !== undefined) return profile.tier;
  return profile?.tier_id;
}

export default function ProfileCard({ profile, onClick, isOnline }) {
  const tier = toTierValue(profile);
  const cardImage = profile?.photo_url || profile?.photoUrl || null;
  const baseName = profile?.name || profile?.username || 'Member';
  const age = profile?.age;
  const displayName = age ? `${baseName}, ${age}` : baseName;
  const city = profile?.city || profile?.location || '';

  return (
    <button type="button" className="ic-profile-card" onClick={onClick}>
      {cardImage ? <img src={cardImage} alt={baseName} className="ic-profile-img" /> : <div className="ic-profile-img" />}
      <div className="ic-profile-overlay" />

      <div className="ic-play-chip" aria-hidden="true">
        <Play size={10} fill="currentColor" strokeWidth={1.5} />
      </div>

      <div className="ic-profile-meta">
        <div className="ic-profile-row">
          <span className="ic-profile-name">{displayName}</span>
          <TierBadge tier={tier} size="sm" />
        </div>
        {city ? <p className="ic-profile-city">{city}</p> : null}
        <p className={`ic-profile-presence ${isOnline ? 'is-live' : 'is-away'}`}>
          {isOnline ? 'Live now' : 'Away'}
          {profile?.rate_per_hour ? ` • ${formatCurrency(profile.rate_per_hour)}/hr` : ''}
        </p>
      </div>
    </button>
  );
}
